import { WorkLocationType } from '../work-location/types';

export const userWorkAttendanceFeatureKey = 'userWorkAttendance';

/** Query of GET api/userAttendances/users. Days are local, "yyyy-MM-dd", both bounds inclusive. */
export type AttendanceUsersQueryModel = {
  from: string;
  to: string;
  /** Matched on the main office of the user; empty = all. */
  salesTeamIds: number[];
  /** Empty = all. */
  groupIds: number[];
  /** Former employees who recorded a presence during the period. */
  includeFormerEmployees: boolean;
};

/** Query of GET api/userAttendances/regularity. Several salespeople are limited to one day. */
export type AttendanceRegularityQueryModel = AttendanceUsersQueryModel & {
  /** Explicit pick; empty = the whole population. */
  userIds: number[];
};

export type AttendanceDayCompleteness = 'None' | 'Full' | 'Half' | 'Partial';

/** One active period of a day, in minutes since local midnight. */
export type AttendanceSegmentModel = {
  startMinutes: number;
  endMinutes: number;
  /** Null when the address is not qualified. */
  workLocationId?: number | null;
  workLocationName: string;
  workLocationType?: WorkLocationType | null;
  /** False: drawn, but moves neither the indicators nor the start and end of the day. */
  countedAsWork: boolean;
};

/** One working day of a salesperson, in minutes since local midnight. */
export type AttendanceDayModel = {
  /** Local day, "yyyy-MM-dd". */
  date: string;
  /** First counted activity. Null = no counted presence that day. */
  startMinutes?: number | null;
  endMinutes?: number | null;
  workedMinutes: number;
  completeness: AttendanceDayCompleteness;
  /** Localized label of the completeness, computed server-side. Read-only. */
  completenessLoc: string;
  /** Target hours of the plan for that weekday. Null without a plan. */
  workStartMinutes?: number | null;
  workEndMinutes?: number | null;
  /** Every recorded activity, counted or not, distinct and sorted. */
  pingMinutes: number[];
  segments: AttendanceSegmentModel[];
};

export type AttendanceUserRegularityModel = {
  userId: number;
  userContactName: string;
  isFormerEmployee: boolean;
  /** Every working day of the period, a day without presence included with null values. */
  days: AttendanceDayModel[];
};

/** Return of GET api/userAttendances/regularity. Indicators describe the displayed rows. */
export type AttendanceRegularityModel = {
  from: string;
  to: string;
  /** (salesperson, day) pairs with a counted presence. */
  presenceCount: number;
  medianStartMinutes?: number | null;
  medianEndMinutes?: number | null;
  /** Median of the individual amplitudes, not the gap between the two medians. */
  medianAmplitudeMinutes?: number | null;
  /** Ordered by name. */
  users: AttendanceUserRegularityModel[];
};
